import { Group } from '@mantine/core';
import { Button } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';

import { EntityType } from '@repo/common/enums/entityType';
import { useCallback } from 'react';
import { useAuthUser, useWorkspace } from '../../../../api';
import { trackDashboardCreated } from '../../../../features/BiDashboard/utils/tracking';
import { entityModalStore } from '../../store';

function DashboardFooter() {
	const navigate = useNavigate();
	const { user } = useAuthUser();
	const { workspace } = useWorkspace();

	const handleClick = useCallback(async () => {
		await entityModalStore.create(
			navigate,
			false,
			true,
			(entityType, entityId) => {
				if (entityType === EntityType.bi_dashboard) {
					trackDashboardCreated('manual', entityId, user, workspace);
				}
			}
		);
	}, [navigate, user, workspace]);

	return (
		<Group position="right">
			<Button
				onClick={handleClick}
				loading={entityModalStore.loading}
				variant="primary"
				size="md"
			>
				Create dashboard
			</Button>
		</Group>
	);
}

const DashboardFooterObserver = observer(DashboardFooter);
export default DashboardFooterObserver;
